import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "src/components/pages/landing/landingPage";
import AustinInspectionCheckpointsPage from "src/components/pages/configurationDrivenInspections/austinInspectionCheckpointsPage";
import TemplatesPage from "src/components/pages/templates/templatesPage";
import { useAppDispatch } from "src/store/store";
import { getAllInspectionTemplates } from "src/store/inspectionTemplateSlice";
import { getInspectionsByUser } from "src/store/inspectionSlice";
import QuestionsPage from "./pages/questions/questionsPage";
import CompletedInspections from "./pages/inspection/completedInspections";
import InspectionRouter from "./pages/inspection/inspectionRouter";
import ConfigurationDrivenInspections from "./pages/configurationDrivenInspections/configurationDrivenInspections";
import WorkflowExecutor from "./pages/configurationDrivenInspections/WorkflowExecutor";
import CheckpointsPage from "./pages/configurationDrivenInspections/CheckpointsPage";
import InspectionReviewPage from "./pages/configurationDrivenInspections/inspectionReview/InspectionReviewPage";
import OverrideCompliancePage from "./pages/configurationDrivenInspections/inspectionReview/OverrideCompliancePage";
import ScannerPage from "./pages/classification/ScannerPage";
import ResultsPage from "./pages/classification/ResultsPage";
import AIResearchResultsPage from "./pages/classification/AIResearchResultsPage";
import ToteItemsPage from "./pages/toteScan/ToteItemsPage";
import ChooseContainerPage from "./pages/toteScan/ChooseContainerPage";
import ConfirmQuantityPage from "./pages/toteScan/ConfirmQuantityPage";
import AddedToContainerPage from "./pages/toteScan/AddedToContainerPage";

const AuthorizedContent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllInspectionTemplates());
    dispatch(getInspectionsByUser());
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/templates/:templateId" element={<QuestionsPage />} />
      <Route path="/completedInspections" element={<CompletedInspections />} />
      <Route path="/inspections/:inspectionId" element={<InspectionRouter />} />
      <Route path="/configurationDrivenInspections" element={<ConfigurationDrivenInspections />} />
      <Route path="/configurationDrivenInspections/workflows/:workflowTemplateId/checkpoints" element={<CheckpointsPage />} />
      <Route path="/configurationDrivenInspections/scheduled/:austinInspectionId/checkpoints" element={<AustinInspectionCheckpointsPage />} />
      <Route path="/configurationDrivenInspections/execute" element={<WorkflowExecutor />} />
      <Route path="/configurationDrivenInspections/:inspectionId/review" element={<InspectionReviewPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/override" element={<OverrideCompliancePage />} />
      <Route path="/classification/scan" element={<ScannerPage />} />
      <Route path="/classification/results" element={<ResultsPage />} />
      <Route path="/classification/aiResults" element={<AIResearchResultsPage />} />
      {/* WADM Tote Scan flow */}
      <Route path="/tote/items" element={<ToteItemsPage />} />
      <Route path="/tote/chooseContainer" element={<ChooseContainerPage />} />
      <Route path="/tote/confirmQuantity" element={<ConfirmQuantityPage />} />
      <Route path="/tote/addedToContainer" element={<AddedToContainerPage />} />
    </Routes>
  );
};

export default AuthorizedContent;
